import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { ComponentProps, FC } from "react";

const TimeIndicatorContainer = styled(motion.div)`
  position: absolute;
  margin-top: -21px;

  z-index: 2;
  pointer-events: none;
`;

const TimeIndicatorShadowTop = styled.div`
  min-height: 20px;
  width: 100%;

  background: linear-gradient(
    180deg,
    hsla(120, 100%, 50%, 0) 0%,
    hsla(120, 100%, 50%, 0.1) 100%
  );
`;

const TimeIndicatorBar = styled.div`
  min-height: 2px;
  width: 100%;

  background-color: hsl(120, 100%, 45%);
`;

const TimeIndicatorShadowBottom = styled.div`
  min-height: 20px;
  width: 100%;

  background: linear-gradient(
    180deg,
    hsla(120, 100%, 50%, 0.1) 0%,
    hsla(120, 100%, 50%, 0) 100%
  );
`;

type TimeIndicatorProps = ComponentProps<typeof TimeIndicatorContainer>;
export const TimeIndicator: FC<TimeIndicatorProps> = (props) => {
  return (
    <TimeIndicatorContainer {...props}>
      <TimeIndicatorShadowTop />
      <TimeIndicatorBar />
      <TimeIndicatorShadowBottom />
    </TimeIndicatorContainer>
  );
};
